import styled from '@emotion/styled';

const common = `
    position: absolute;
    left: 0;
    background-color: black;
    content: "";
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
`;

export const StyledCheckMark = styled.div`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;

  &:before {
    top: 45%;
    height: 55%;
    width: 2px;
    ${common}
  }

  &:after {
    bottom: 0;
    height: 2px;
    width: 100%;
    ${common}
  }
`;
